export default __webpack_public_path__ + "static/media/user5.40868ed5.png";